import * as constants from './constants';
import controller from './controller';

const dispatchFail = (dispatch, failType, error) => {
  dispatch({ type: failType, payload: { loading: false, error } });

  throw error;
};

export function resetError() {
  return { type: constants.RESET_ERROR, payload: { error: null } };
}

export function getVehicleMakes(showDeleted = false) {
  return dispatch => controller.getVehicleMakes(showDeleted).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_VEHICLE_MAKE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_VEHICLE_MAKE_SUCCESS,
      // response.data.makes - тут такая вложенная конструкция возвращается, т.к возвращается вложенный объект
      payload: { makes: response.data.makes, error: null },
    });
  });
}

export function getVehicleModels(makeId) {
  return dispatch => controller.getVehicleModels(makeId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_VEHICLE_MODEL_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_VEHICLE_MODEL_SUCCESS,
      // response.data.models - тут тоже вложенная конструкция..
      payload: { models: response.data.models, selectedMakeId: makeId, error: null },
    });
  });
}

export function getVehicleGenerations(modelId) {
  return dispatch => controller.getVehicleGenerations(modelId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_VEHICLE_GENERATION_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_VEHICLE_GENERATION_SUCCESS,
      payload: { generations: response.data.generations, selectedModelId: modelId, error: null },
    });
  });
}

export function getVehicleModifications(generationId) {
  return dispatch => controller.getVehicleModifications(generationId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_VEHICLE_MODIFICATION_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_VEHICLE_MODIFICATION_SUCCESS,
      payload: { modifications: response.data.modifications, selectedGenerationId: generationId, error: null },
    });
  });
}

export function getClientVehicles(data) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_CLIENT_VEHICLES,
      payload: { loading: true, error: undefined, clientIdClientVehicles: data.clientId, clientVehicles: [] },
    });
    return controller.getClientVehicles(data)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(dispatch, constants.FETCH_CLIENT_VEHICLES_FAIL, response.errorData);
        }

        return dispatch({
          type: constants.FETCH_CLIENT_VEHICLES_SUCCESS,
          payload: { loading: false, clientVehicles: response.data, error: undefined },
        });
      });
  };
}

export function clearClientVehicles() {
  return {
    type: constants.CLEAR_CLIENT_VEHICLES_SUCCESS,
    payload: { clientVehicles: [], clientIdClientVehicles: null },
  };
}

export function getClientVehicle(data) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_CLIENT_VEHICLE,
      payload: { loading: true, clientVehicle: {}, clientVehicleRequest: data, error: undefined },
    });

    return controller.getClientVehicle(data)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(dispatch, constants.FETCH_CLIENT_VEHICLE_FAIL, response.errorData);
        }

        return dispatch({
          type: constants.FETCH_CLIENT_VEHICLE_SUCCESS,
          payload: { loading: false, clientVehicle: response.data, error: undefined },
        });
      });
  };
}

export function clearClientVehicle() {
  return {
    type: constants.CLEAR_CLIENT_VEHICLE_SUCCESS,
    payload: { clientVehicle: {}, clientVehicleRequest: {} },
  };
}

export function createClientVehicle(data) {
  return dispatch => {
    dispatch({
      type: constants.CREATE_CLIENT_VEHICLE,
      payload: { loading: true, clientVehicle: {}, error: undefined },
    });

    return controller.postClientVehicle(data).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.CREATE_CLIENT_VEHICLE_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.CREATE_CLIENT_VEHICLE_SUCCESS,
        payload: { clientVehicle: response.data, error: undefined },
      });
    });
  };
}

export function updateClientVehicle(data) {
  return dispatch => {
    dispatch({
      type: constants.UPDATE_CLIENT_VEHICLE,
      payload: { loading: true, error: undefined },
    });

    return controller.putClientVehicle(data).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.UPDATE_CLIENT_VEHICLE_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.UPDATE_CLIENT_VEHICLE_SUCCESS,
        payload: { clientVehicle: response.data, error: undefined },
      });
    });
  };
}

export function makeClientVehiclePrimary(data) {
  return dispatch => {
    dispatch({
      type: constants.MAKE_CLIENT_VEHICLE_PRIMARY,
      payload: { loading: true, error: undefined },
    });

    return controller.makeClientVehiclePrimary(data).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.MAKE_CLIENT_VEHICLE_PRIMARY_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.MAKE_CLIENT_VEHICLE_PRIMARY_SUCCESS,
        payload: { clientVehicle: response.data, error: undefined, clientVehicles: data.list },
      });
    });
  };
}

export function deleteClientVehicle(vehicleId, clientId) {
  return dispatch => controller.deleteClientVehicle(vehicleId, clientId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_CLIENT_VEHICLE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.DELETE_CLIENT_VEHICLE_SUCCESS,
      payload: { clientVehicle: {}, error: undefined },
    });
  });
}

export function findVehicleByNumber(number) {
  return dispatch => {
    dispatch({
      type: constants.FIND_VEHICLE,
      payload: { loading: true, foundVehicles: null, foundVehiclesError: undefined },
    });

    controller.findVehicleByNumber(number).then(response => {
      if (response.errorData) {
        // поиск авто по номеру использует свое собственное состояние ошибки
        dispatch({
          type: constants.FIND_VEHICLE_FAIL,
          payload: { loading: false, foundVehiclesError: response.errorData },
        });

        throw response.errorData;
      }

      return dispatch({
        type: constants.FIND_VEHICLE_SUCCESS,
        payload: { foundVehicles: response.data, loading: false, foundVehiclesError: undefined },
      });
    });
  };
}

export function clearFoundVehicles() {
  return {
    type: constants.CLEAR_FOUNDED_VEHICLE,
    payload: { foundVehicles: [] },
  };
}

export function addVehicleToClient(data) {
  return dispatch => controller.addVehicleToClient(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.ADD_VEHICLE_TO_CLIENT_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.ADD_VEHICLE_TO_CLIENT_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function getCarmenMakes() {
  return dispatch => {
    dispatch({
      type: constants.GET_CARMEN_VEHICLE,
      payload: { loading: true, carmenMakes: [], error: undefined },
    });

    controller.getCarmenMakes().then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.GET_CARMEN_VEHICLE_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.GET_CARMEN_VEHICLE_SUCCESS,
        payload: { carmenMakes: response.data, loading: false, error: undefined },
      });
    });
  };
}

export const updateCarmenMakes = (id, data) => {
  return dispatch => controller.updateCarmenMakes(id, data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_CARMEN_VEHICLE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_CLIENT_VEHICLE_SUCCESS,
      payload: { error: undefined },
    });
  });
};
